var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "mx-5 mt-5 mb-15 md:mx-15 md:mt-15 2xl:mx-20 2xl:mt-20 2xl:mb-20"
  }, [_vm._v("\n        Activités extra-professionnelles\n    ")]), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('add-button', {
    staticClass: "mx-5 md:mx-15 2xl:mx-20",
    attrs: {
      "id": "extrapro_add_activity",
      "libelle": "Ajouter une activité"
    },
    on: {
      "add": function ($event) {
        return _vm.addActivity();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.form.activites.length > 0 ? _c('div', [_c('list-grid', {
    ref: "listActivities",
    attrs: {
      "list-items": _vm.form.activites,
      "grid": "grid-cols-11 md:grid-cols-12",
      "is-accordion-items": true
    },
    on: {
      "displayNum": function (num) {
        _vm.activityDisplayed = num;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-2 md:col-start-2 col-span-5 md:col-span-2"
        }, [_vm._v("Période")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block col-span-2"
        }, [_vm._v("Type d'activité")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-3"
        }, [_vm._v("Activité")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block col-span-2"
        }, [_vm._v("Environnement")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block col-span-2"
        }, [_vm._v("Durée "), _c('span', {
          staticClass: "hidden lg:inline"
        }, [_vm._v("hebdomadaire")])])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('icon', {
          staticClass: "text-pink-600 col-span-1 justify-self-end md:justify-self-center transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.activityDisplayed == num
          },
          attrs: {
            "name": "chevron-right"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-2 text-base font-normal"
        }, [item.debut ? _c('span', [_vm._v(_vm._s(new Date(item.debut).getFullYear()) + " - ")]) : _vm._e(), item.debut && !item.fin ? _c('span', [_vm._v("en cours")]) : _vm._e(), item.fin ? _c('span', [_vm._v(_vm._s(new Date(item.fin).getFullYear()))]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block col-span-2 text-base text-indigo-600 font-normal"
        }, [_vm._v("\n                    " + _vm._s(item.type) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-3 text-base text-pink-600 font-normal truncate"
        }, [_vm._v("\n                    " + _vm._s(item.activite) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:inline-block col-span-2 text-base font-normal truncate"
        }, [_vm._v("\n                    " + _vm._s(item.environnement) + "\n                ")]), _vm._v(" "), item.duree != undefined && item.duree != '' ? _c('div', {
          staticClass: "hidden md:inline-block col-span-2 text-base font-normal"
        }, [_vm._v("\n                    " + _vm._s(item.duree) + " h\n                ")]) : _c('div', {
          staticClass: "hidden md:inline-block col-span-2 text-base font-normal"
        })];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-select', {
          staticClass: "md:col-span-4",
          attrs: {
            "necessary": true,
            "name": "type",
            "libelle": "Type d'activité",
            "datas": [{
              value: 'Culturelle'
            }, {
              value: 'Artistique'
            }, {
              value: 'Sportive'
            }, {
              value: 'Autre'
            }],
            "value": item.type
          },
          on: {
            "input": function (newValue) {
              item.type = newValue;
            }
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.type === 'Autre' ? _c('input-text', {
          staticClass: "md:col-span-4",
          attrs: {
            "necessary": true,
            "value": item.type_precision,
            "libelle": "Autre type d'activité",
            "name": "type_precision"
          },
          on: {
            "input": function (newValue) {
              item.type_precision = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-4",
          attrs: {
            "necessary": true,
            "name": "activite",
            "libelle": "Activité",
            "value": item.activite
          },
          on: {
            "input": function (newValue) {
              item.activite = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-4",
          attrs: {
            "necessary": true,
            "name": "duree",
            "libelle": "Durée hebdomadaire (en h)",
            "value": item.duree
          },
          on: {
            "input": function (newValue) {
              item.duree = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-4",
          attrs: {
            "necessary": true,
            "name": "environnement",
            "libelle": "Environnement (à titre personnel, au sein d'une structure...)",
            "value": item.environnement
          },
          on: {
            "input": function (newValue) {
              item.environnement = newValue;
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-8 grid grid-cols-2 gap-4"
        }, [_c('date-picker', {
          staticClass: "col-span-full md:col-span-1",
          attrs: {
            "name": "debut",
            "necessary-date": true,
            "libelle": "Début",
            "format": "yyyy",
            "min-view": "year",
            "value": item.debut
          },
          on: {
            "input": function (newValue) {
              if (item.fin == '' || _vm.$verifyDates({
                debut: newValue,
                fin: item.fin
              })) {
                item.debut = newValue;
              } else {
                _vm.badDates();
              }
              ;
              _vm.sortActivites();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-1",
          attrs: {
            "name": "fin",
            "necessary-date": true,
            "libelle": "Fin",
            "format": "yyyy",
            "min-view": "year",
            "value": item.fin
          },
          on: {
            "input": function (newValue) {
              if (item.debut == '' || _vm.$verifyDates({
                debut: item.debut,
                fin: newValue
              })) {
                item.fin = newValue;
              } else {
                item.fin = '';
                _vm.badDates();
              }
              ;
            }
          }
        })], 1), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6 lg:col-start-1",
          attrs: {
            "name": "raisons",
            "necessary": true,
            "libelle": "Principales activités exercées",
            "size": "5",
            "value": item.raisons
          },
          on: {
            "input": function (newValue) {
              item.raisons = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "appris",
            "necessary": true,
            "libelle": "Principales réalisations que je souhaite mettre en valeur",
            "size": "5",
            "value": item.appris
          },
          on: {
            "input": function (newValue) {
              item.appris = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "competences",
            "necessary": true,
            "libelle": "Compétences acquises",
            "size": "5",
            "value": item.competences
          },
          on: {
            "input": function (newValue) {
              item.competences = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "remarques",
            "libelle": "Commentaires",
            "size": "5",
            "value": item.remarques
          },
          on: {
            "input": function (newValue) {
              item.remarques = newValue;
            }
          }
        }), _vm._v(" "), _c('delete-button', {
          attrs: {
            "libelle": "Supprimer cette activité"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.activites, num);
            }
          }
        })], 1)];
      }
    }], null, false, 2556684497)
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }